import createIncident from './util';

export const POST_INCIDENT_REQUEST = 'POST_INCIDENT_REQUEST';
export const POST_INCIDENT_SUCCESS = 'POST_INCIDENT_SUCCESS';
export const POST_INCIDENT_FAILURE = 'POST_INCIDENT_FAILURE';

const postIncidentRequest = () => ({ type: POST_INCIDENT_REQUEST });
const postIncidentSuccess = payload => ({ type: POST_INCIDENT_SUCCESS, payload });
const postIncidentFailure = payload => ({ type: POST_INCIDENT_FAILURE, payload });

const sendNotification = (user, service) => async (dispatch) => {
  try {
    dispatch(postIncidentRequest());
    const incidentResponse = await createIncident(service);
    if (incidentResponse.status === 201) {
      dispatch(postIncidentSuccess(incidentResponse.data.incident));
    } else {
      throw incidentResponse;
    }
  } catch {
    const code = 500;
    const message = 'Internal Server Error';
    const error = { code, message };
    dispatch(postIncidentFailure(error));
  }
};

export const clearIncidentData = () => async (dispatch) => {
  dispatch(postIncidentSuccess(null));
  dispatch(postIncidentFailure(null));
};

export default sendNotification;
